import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Select,
  MenuItem,
  Button,
  InputBase,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material";
import { Clock9, DeleteIcon, Mic as MicIcon, Trash2 } from "lucide-react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Add,
  Delete,
  DeleteOutline,
  ErrorOutline,
  KeyboardArrowDown,
} from "@mui/icons-material";
import axios from "axios";
import DeleteRecordingModal from "../modals/DeleteRecordingModal";
import AudioDuration from "../modals/AudioDuration";
import AudioPlayer from "../modals/AudioPlayer";
import FileDownloader from "../modals/FileDownloader";
import NewRecordingModal from "../modals/NewRecordingModal";
import { useRecordingFlow } from "../../hooks/useRecordingFlow";

const Recordings = () => {
  const [recordings, setRecordings] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );
  const [openNewRecording, setOpenNewRecording] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);

  const recordingFlow = useRecordingFlow({
    onSuccess: (updatedRecordings) => {
      setRecordings(updatedRecordings);
      const prevIds = new Set(
        (recordings || []).map((r) => r.M?.rec_id?.S).filter(Boolean)
      );
      const newRec =
        updatedRecordings?.find(
          (r) => r.M?.rec_id?.S && !prevIds.has(r.M.rec_id.S)
        ) ||
        (updatedRecordings?.length
          ? updatedRecordings[updatedRecordings.length - 1]
          : null);
      const newId = newRec?.M?.rec_id?.S;
      if (newId && typeof window !== "undefined" && window.__twilanswerAssistantPush) {
        window.__twilanswerAssistantPush({
          type: "recording_added",
          recordingId: newId,
        });
      }
      setSuccessMsg("Record was successfully stored to organization");
      setTimeout(() => {
        setSuccessMsg(null);
        setOpenNewRecording(false);
      }, 3000);
    },
  });

  const {
    record_type,
    setRecordType,
    recording_data,
    setRecordingData,
    handleFileUpload,
    handleClick,
    buttonState,
    formatTime,
    time,
    maxTime,
    restartRecording,
    storeRecording,
    openSnack,
    setOpenSnack,
    snackMsg,
    setSnackMsg,
    fileInputRef,
    uploadedFile,
    audioPreviewUrl,
    isConverting,
    isRecording,
    setUploadedFile,
    step,
    setStep,
  } = recordingFlow;

  return (
    <div className="pt-7 px-4">
     <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={openSnack}
            onClose={() => setOpenSnack(false)}
            message={snackMsg}
            key={snackMsg}
          />
      <div className="flex justify-between items-center">
      <div className="lg:text-[22px] text-[20px] font-bold mb-4 lg:mt-0 mt-8 ">
        Recordings
      </div>

    <NewRecordingModal
  open={openNewRecording}
  setOpen={setOpenNewRecording}
  recordingData={recording_data}
  setRecordingData={setRecordingData}
  recordType={record_type}
  setRecordType={setRecordType}
  handleFileUpload={handleFileUpload}
  handleClick={handleClick}
  buttonState={buttonState}
  formatTime={formatTime}
  time={time}
  maxTime={maxTime}
  restartRecording={restartRecording}
  storeRecording={storeRecording}
  openSnack = {openSnack}
  setOpenSnack = {setOpenSnack}
  snackMsg = {snackMsg}
  setSnackMsg = {setSnackMsg}
  fileInputRef={fileInputRef}
  uploadedFile={uploadedFile}
  audioPreviewUrl={audioPreviewUrl}
  isConverting={isConverting}
  isRecording={isRecording}
  setUploadedFile={setUploadedFile}
  step={step}
  setStep={setStep}
/>
        
        <div className="">
          <Button
            variant="contained"
              color="primary"
              sx={{              py: "7px",
              px: "20px",
              borderRadius: "6px",
              fontSize: {lg:"14px", xs:'12px'},
            }}
            onClick={()=> setOpenNewRecording(true)}
          >
            <Add sx={{ fontSize: "20px", position: "relative", bottom: 1 }} />
            Add Recording
          </Button>
        </div>
      </div>

      {/* <div className="bg-white rounded-[13px] w-full my-5 lg:px-12 px-4 py-6 space-y-4">
        <div className="lg:text-[15px] text-[14px] text-[#030229] font-semibold">
          Add Recording
        </div>

        {err_msg && (
          <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
            <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
          </div>
        )}

        <div className="lg:ml-8 space-y-2">
          <div className="lg:w-[200px]">
            <Select
              IconComponent={KeyboardArrowDown}
              fullWidth
              value={record_type}
              onChange={(e) => setRecordType(e.target.value)}
              className="mb-2 bg-[#F7F7F8]"
              sx={{
                fontSize: "13px",
                padding: "2px 8px", // Adjust padding here
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                "& .MuiSelect-select": {
                  padding: "2px 8px", // Adjust padding for the text inside Select
                },
              }}
            >
              <MenuItem value="upload_mp3">Upload MP3</MenuItem>
              <MenuItem value="record_now">Record Now</MenuItem>
            </Select>
          </div>

          <div className=" lg:flex items-center w-full">
            <div className="lg:flex-1 ">
              {record_type === "upload_mp3" && (
                <div className=" flex items-center space-x-4 lg:ml-[80px] mb-2 lg:mb-0">
                 
                  <div className="relative inline-block">
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileUpload}
                      accept="audio/*"
                      className="hidden"
                      disabled={isRecording || isConverting}
                    />
                    
                    <img
                      src="/icons/upload.png"
                      className="lg:w-[50px] w-[30px] "
                      onClick={() => fileInputRef.current?.click()}
                    />

                    <div className="lg:text-[14px] text-[13px] italic ">
                      {" "}
                      {uploadedFile
                        ? uploadedFile.name
                        : "No file uploaded"}{" "}
                    </div>
                  </div>
                </div>
              )}

              {record_type === "record_now" && (
                <div className="flex items-center space-x-1 mb-2 lg:mb-0">
                  <div className="audio-input-ui">
                    <button
                      className={`record-button ${buttonState}`}
                      onClick={handleClick}
                    ></button>
                    <span className="audio-timer">
                      {formatTime(time)}/{formatTime(maxTime)}
                    </span>
                  </div>


                  {buttonState === "play" && (
                    <DeleteOutline
                      className="lg:w-[17px] w-[15px] cursor-pointer"
                      onClick={() => {
                        restartRecording();
                      }}
                    />
                  )}
                </div>
              )}
            </div>

            <div className="lg:w-[240px] w-full lg:mr-5 mb-2 lg:mb-0">
              <InputBase
                placeholder="Recording name"
                value={recording_data.title}
                onChange={(e) =>
                  setRecordingData({ ...recording_data, title: e.target.value })
                }
                sx={{
                  bgcolor: "#F7F7F8",
                  width: "100%",
                  px: 2,
                  fontSize: "14px",
                }}
              />
            </div>

            <div>
              <Button
                variant="contained"
                  color="primary"
                  sx={{
                  py: "6px",
                  px: "8px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                disabled={
                  loader ||
                  (record_type === "upload_mp3" && !uploadedFile) ||
                  (record_type === "record_now" && !audioBlob)
                }
                onClick={() => {
                  if (recording_data.title.length < 1) {
                    setErrorMsg("no record title");
                  } else {
                    storeRecording();
                  }
                }}
              >
                {loader ? (
                  <CircularProgress
                    size={"1.3rem"}
                    sx={{ color: "white", animationDuration: "0.7s" }}
                  />
                ) : (
                  "  Save Recording"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div> */}

      <div className=" rounded-[13px]  w-full mt-2">
        {/* <div className="lg:text-[15px] text-[13px] text-[#030229] ml-2 font-semibold ">
          Recording List
        </div> */}
        {successMsg && (
          <Alert color="success" sx={{ ml: 1 }}>
            <div className="text-[14px] ">{successMsg}</div>
          </Alert>
        )}
        {recordings && recordings.length > 0 ? (
          <RecordingList
            recordings={recordings}
            setRecordings={setRecordings}
          />
        ) : (
          <Alert color="info" sx={{ ml: 1 }}>
            <div className="text-[14px] ">
              You do not have any recordings created yet. Add a recording above
              to get started. Need help?{" "}
              <a
                className="hover:text-red-600 hover:underline"
                href="mailto:hello@twilanswer.com"
              >
                Contact Support
              </a>
              .
            </div>
          </Alert>
        )}
      </div>
    </div>
  );
};

export default Recordings;
const RecordingList = ({ recordings, setRecordings }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [openModalIndex, setOpenModalIndex] = useState(null); // Track which row's modal is open
  const [loader, setLoader] = useState(false);

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const sortedRows = [...recordings].sort((a, b) => {
    if (sortConfig.key) {
      const isAscending = sortConfig.direction === "asc";
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) return isAscending ? -1 : 1;
      if (aValue > bValue) return isAscending ? 1 : -1;
    }
    return 0;
  });

  function formatTimestamp(timestamp) {
    const date = new Date(Number(timestamp));
    if (isNaN(date.getTime())) return "Invalid timestamp";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
  }

  return (
    <TableContainer className="w-full overflow-x-auto lg:overflow-hidden">
      <Table style={{ minWidth: "1100px" }}>
        <TableHead className="bg-[#F9FAFB] ">
          <TableRow>
            {/* <TableCell onClick={() => handleSort("created")} sx={{ color:'#6B7280'}} >
              Created
            </TableCell> */}
            <TableCell
              onClick={() => handleSort("name")}
              sx={{ color: "#6B7280", fontSize:'12px', fontWeight:700}}
            >
              NAME
            </TableCell>
            <TableCell
              onClick={() => handleSort("Duration")}
              sx={{ color: "#6B7280", fontSize:'12px', fontWeight:700 }}
            >
              DURATION
            </TableCell>
            <TableCell sx={{ color: "#6B7280", fontSize:'12px', fontWeight:700 }}>CREATED ON</TableCell>
            <TableCell sx={{ color: "#6B7280", fontSize:'12px', fontWeight:700 }}>STATUS</TableCell>
            <TableCell sx={{ color: "#6B7280", fontSize:'12px', fontWeight:700 }}>ACTIONS</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((row, index) => (
            <TableRow
              key={index}
              className={index % 2 === 0 ? "bg-white" : "bg-[#FAFAFB]"}
            >
              {/* <TableCell>{formatTimestamp(row.M.last_updated.N)}</TableCell> */}
              <TableCell>
                <div className="flex items-center space-x-1">
                  {" "}
                  <MicIcon color="#6B7280" className="w-[17px]" />
                  <div className="font-semibold text-[15px]">
                    {row.M.title.S}
                  </div>
                </div>{" "}
              </TableCell>
              <TableCell>
                <div className="flex items-center space-x-1">
                  {" "}
                  <Clock9 color="#6B7280" className="w-[17px]" />
                  <div className="">
                    <AudioDuration url={row.M.url.S} />
                  </div>
                </div>
              </TableCell>
              <TableCell>{formatTimestamp(row.M.last_updated.N)}</TableCell>
              <TableCell>
                {/* {row.M.url.S} */}
                {/* <FileDownloader url={row.M.url.S} title={row.M.title.S} /> */}
                {row.M.status?.S === "active" ? (
                  <div className="bg-[rgba(0,186,37,0.1)] text-[#166534] w-fit   text-[14px] lg:text-[13px] px-3 text-center  rounded-[15px] ">
                    active
                  </div>
                ) : (
                  <div className="bg-[#F3F4F6] text-[#1F2937] w-fit   text-[14px] lg:text-[13px] px-3 text-center  rounded-[15px] ">
                    Inactive
                  </div>
                )}
              </TableCell>
              <TableCell>
                <div className="flex items-center space-x-3">
                  <AudioPlayer url={row.M.url.S} />

                  <Trash2
                    className="w-[20px] text-red-700 cursor-pointer"
                    onClick={() => setOpenModalIndex(index)}
                  />
                </div>
                {/* <img
                  src="/icons/delete_2.png"
                  className="w-[24px] cursor-pointer"
                
                /> */}
                {openModalIndex === index && (
                  <DeleteRecordingModal
                    loader={loader}
                    setLoader={setLoader}
                    open={true} // Always open for the current index
                    setOpen={() => setOpenModalIndex(null)} // Close modal
                    recording_id={row.M.rec_id.S}
                    setRecordings={setRecordings}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
